import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import { logger } from "redux-logger";
import EngageGPTReducer from "./EngageGPT/EngageGPTSlice";

export const rootReducer = combineReducers({ engageGPTState: EngageGPTReducer });
export type RootState = ReturnType<typeof rootReducer>;
const store = configureStore({ reducer: rootReducer });
export type AppDispatch = typeof store.dispatch;
export default store;
